import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
Vue.use(Vuex)

const state = {
  isShowFooter: true
}
export default new Vuex.Store({
  state,
  mutations: {
    UPDATE_SHOW_FOOTER (state, isShowFooter) {
      state.isShowFooter = isShowFooter
    },
    UPDATE_TITLE (state, status) {
      document.title = status
      if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
        var i = document.createElement('iframe')
        i.src = '/favicon.ico'
        i.style.display = 'none'
        i.onload = function () {
          setTimeout(function () {
            i.remove()
          }, 9)
        }
        document.body.appendChild(i)
      }
    }
  },
  getters: {
    isShowFooter: state => state.isShowFooter
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js